var map = {
	"./1.jpg": "ed50",
	"./2.jpg": "7b27",
	"./3.jpg": "cd88",
	"./4.jpg": "1ca4",
	"./5.jpg": "a970",
	"./6.jpg": "202d",
	"./7.jpg": "8901"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9b23";